<template>
  <div class="login-welcome">
    <a-alert
      v-if="data?.attraction_register_reward?.credit_coins"
      type="info"
      showIcon
      class="alert-wrapper"
    >
      <template #message>
        <div class="font-normal">
          {{ $t('zhu-ce-cheng-gong') }}，{{ $t('li-ji') }}
          <NuxtLink :to="{ name: PageKey.SUBSCRIBE }">
            {{ $t('qu-sheng-ji') }}
          </NuxtLink>
          ，{{
            $t(
              'jie-suo-geng-duo-la-xin-jiang-li-huo-zhe-sheng-cheng-ni-zi-ji-de'
            )
          }}
          <a @click="showLink">{{ $t('zhuan-shu-yao-qing-lian-jie') }}</a>
          ，{{ $t('yao-qing-hao-you-yi-qi-ling-qu-quan-yi-ba') }}
        </div>
      </template>
    </a-alert>
    <div class="flex-col flex items-center">
      <iconpark-icon
        size="56"
        class="mt-[50px] text-[#29E69C]"
        name="circle-check"
      ></iconpark-icon>
      <div class="text-[20px] font-medium mt-[16px]">
        {{ $t('ge-ren-ti-yan-ban-chuang-jian-cheng-gong') }}
      </div>
      <div class="mt-[10px] text-font-60 text-14">
        {{ $t('nin-yi-zhu-ce-cheng-gong') }}
        <span v-if="data?.personal_experience_register_info">
          {{ $t('xin-yong-hu-zhu-ce-yi-wei-nin-zi-dong-fa-fang') }}
          <span class="text-primary">{{ coins }}{{ $t('yan-bi') }}</span>
          <span>
            {{ runtime.public.area === 'US' ? '(' : '（' }}
            {{ $t('you-xiao-qi-zhi') }}
            {{
              timezoneFormat(
                data?.personal_experience_register_info.expired_time
              )
            }}
            {{ runtime.public.area === 'US' ? ')' : '）' }}
          </span>
          {{ runtime.public.area === 'US' ? '.' : '，' }}
          {{ $t('kuai-lai-kai-shi-ni-de-3d-shi-pin-chuang-zuo-zhi-lv-ba') }}
        </span>
      </div>
      <Intro :list="list">
        <a-button
          type="primary"
          class="mt-[20px] min-w-[102px]"
          @click="goLink"
        >
          {{ $t('kai-shi-you-yan') }}
        </a-button>
      </Intro>
    </div>
    <XAttract
      v-if="isChinese()"
      type="fixed"
      :source="AttractSource.REGISTER"
    ></XAttract>
  </div>
</template>

<script lang="ts" setup>
import type { UserAwardInfo } from '~/api/interface'
import { useLoginInviteModal } from '~/hooks/useModal/modals/registerInvite'
import Intro from '~/features/intro/index.vue'
import XAttract from '~/components/xAttract/index.vue'
import { AttractSource } from '~/components/xAttract/constant'
import { loginTask } from '~/utils/loginTask.ts'
import { useTime } from '~/hooks/useTime'
import { redirectTo } from '~/utils'
import { PageKey } from '~/constants/page'

const props = defineProps<{
  data: UserAwardInfo
}>()

const { timezoneFormat } = useTime()

const { $t } = useNuxtApp()
const runtime = useRuntimeConfig()

const list = [
  {
    name: $t('hai-liang-3d-jiao-se'),
    desc: $t(
      'gao-zhi-liang-chao-xie-shi-3d-xu-ni-ren-jiao-se-yi-zhan-jin-xuan'
    ),
    url: getFeUrl('/youyan-platform/png/intro-item1.png'),
  },
  {
    name: $t('aigc-nei-rong-sheng-cheng'),
    desc: $t(
      'jiao-se-xing-xiang-dong-hua-sheng-yin-deng-guang-yun-jing-ai-sheng-cheng-nei'
    ),
    url: getFeUrl('/youyan-platform/png/intro-item2.png'),
  },
  {
    name: $t('yi-zhan-shi-chuang-zuo'),
    desc: $t(
      'jian-dan-yi-yong-kuai-su-shang-shou-ling-ji-chu-chuang-zuo-gao-zhi-liang-shi-pin'
    ),
    url: getFeUrl('/youyan-platform/png/intro-item3.png'),
  },
]

const coins = computed(
  () => props.data?.personal_experience_register_info?.credit_coins
)

const showLink = () => {
  useLoginInviteModal({
    title: $t('ni-de-zhuan-shu-yao-qing-lian-jie-yi-sheng-cheng'),
    type: 'link',
  })
}

const goLink = async () => {
  if (loginTask.tasks.length > 0) {
    await loginTask.flush()
    return
  }
  const route = useRoute()
  const redirect: any = route.query?.redirect
  redirectTo(redirect)
}

onMounted(() => {
  trackEvent(TRACK_EVENT.USER_REGISTER_SUCCESS)
})
</script>

<style lang="scss" scoped>
.login-welcome {
  @apply h-full flex-y-center justify-center relative min-h-[680px] m-auto;
  .alert-wrapper {
    @apply absolute left-1/2 -translate-x-1/2 top-[14px] w-[730px];
    padding: 14px 18px;
    background: var(--purple-2);
    box-shadow: 0px 6px 16px 0px rgba(21, 46, 106, 0.08);
  }
}
</style>
